import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Typography,
  Switch,
  FormControlLabel,
  MenuItem,
  Avatar,
  Select,
  InputLabel,
  FormControl
} from '@mui/material';

const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

export default function LampCreate({ onSuccess, onCancel }) {
  const [devEUNumber, setDevEUNumber] = useState('');
  const [zonaid, setZonaId] = useState('');
  const [lightingmodeid, setLightingModeId] = useState('');
  const [manufacturer, setManufacturer] = useState('');
  const [model, setModel] = useState('');
  const [power, setPower] = useState('');
  const [colorTemperature, setColorTemperature] = useState('');
  const [ipRating, setIpRating] = useState('');
  const [operatingModes, setOperatingModes] = useState('');
  const [installationAddress, setInstallationAddress] = useState('');
  const [serviceDate, setServiceDate] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [material, setMaterial] = useState('');
  const [lifespanHours, setLifespanHours] = useState('');
  const [height, setHeight] = useState('');
  const [installationType, setInstallationType] = useState('');
  const [weight, setWeight] = useState('');
  const [modeOfOperation, setModeOfOperation] = useState('');
  const [status, setStatus] = useState(true);
  const [currentPower, setCurrentPower] = useState('');
  const [currentDimming, setCurrentDimming] = useState('');

  const [zones, setZones] = useState([]);
  const [lightingModes, setLightingModes] = useState([]);

  useEffect(() => {
    const fetchZones = async () => {
      const res = await fetch(`${SERVER_URL}/api/zonas`);
      setZones(await res.json());
    };

    const fetchLightingModes = async () => {
      const res = await fetch(`${SERVER_URL}/api/lightingmodes`);
      setLightingModes(await res.json());
    };

    fetchZones();
    fetchLightingModes();
  }, []);

  const postData = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/api/streetlamps`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          devEUNumber: devEUNumber || "NEPOZNAT",
          zonaid: zonaid || null,
          lightingmodeid: lightingmodeid || null,
          manufacturer: manufacturer || "Nepoznat proizvođač",
          model: model || "Nepoznat model",
          power: power ? parseFloat(power) : 0,
          colorTemperature: colorTemperature ? parseInt(colorTemperature) : 4000,
          ipRating: ipRating || "IP65",
          installationAddress: installationAddress || "Nepoznata lokacija",
          serviceDate: serviceDate,
          latitude: latitude ? parseFloat(latitude) : 0,
          longitude: longitude ? parseFloat(longitude) : 0,
          material: material || "Nepoznato",
          lifespanHours: lifespanHours ? parseInt(lifespanHours) : 50000,
          height: height ? parseFloat(height) : 5,
          installationType: installationType || "Nepoznato",
          weight: weight ? parseFloat(weight) : 0,
          modeOfOperation: modeOfOperation || "manual",
          status: status ? "active" : "inactive",
          currentPower: currentPower ? parseFloat(currentPower) : 0,
          currentDimming: currentDimming ? parseFloat(currentDimming) : 0
        })
      });

      if (!response.ok) {
        console.error(await response.text());
        return;
      }

      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  const fieldStyle = {
    '& .MuiOutlinedInput-root': {
      color: '#ff9800',
      '& fieldset': {
        borderColor: '#ff9800'
      },
      '&:hover fieldset': {
        borderColor: '#ffa726'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ff9800'
      }
    },
    '& .MuiInputLabel-root': {
      color: '#ff9800'
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#ff9800'
    }
  };

  return (
    <div style={{ backgroundColor: '#00122E', width: '100%', padding: '20px' }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 800, width: '100%', backgroundColor: '#00122E', color: '#ff9800', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60, color: '#ff9800' }}>Lamp</Avatar>}
            title={<Typography variant="h6" sx={{ color: '#ff9800' }}>Nova ulična lampa</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>

              <Grid item xs={12} sm={6}>
                <TextField label="DevEU Number" value={devEUNumber}
                  onChange={e => setDevEUNumber(e.target.value)}
                  fullWidth margin="normal"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                  sx={fieldStyle}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin="normal" variant="outlined" sx={fieldStyle}>
                  <InputLabel id="zona-label">
                    Zona
                  </InputLabel>

                  <Select
                    labelId="zona-label"
                    value={zonaid || ''}
                    label="Zona"
                    onChange={e => setZonaId(e.target.value)}
                  >
                    {zones.map(zone => (
                      <MenuItem key={zone.id} value={zone.id}>{zone.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  sx={fieldStyle}
                >
                  <InputLabel id="lighting-mode-label">
                    Lighting Mode
                  </InputLabel>

                  <Select
                    labelId="lighting-mode-label"
                    value={lightingmodeid || ''}
                    label="Lighting Mode"
                    onChange={e => setLightingModeId(e.target.value)}
                  >
                    {lightingModes.map(mode => (
                      <MenuItem key={mode.id} value={mode.id}>
                        {mode.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField label="Manufacturer" value={manufacturer}
                  onChange={e => setManufacturer(e.target.value)}
                  fullWidth margin="normal"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                  sx={fieldStyle}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField label="Model" value={model}
                  onChange={e => setModel(e.target.value)}
                  fullWidth margin="normal"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                  sx={fieldStyle}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField label="Power (W)" type="number" value={power}
                  onChange={e => setPower(e.target.value)}
                  fullWidth margin="normal"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                  sx={fieldStyle}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField label="Color Temperature (K)" type="number" value={colorTemperature}
                  onChange={e => setColorTemperature(e.target.value)}
                  fullWidth margin="normal"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                  sx={fieldStyle}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
<TextField
  label="Service Date"
  type="date"
  value={serviceDate}
  onChange={e => setServiceDate(e.target.value)}
  fullWidth
  margin="normal"
  InputLabelProps={{
    style: { color: '#ff9800' },
    shrink: true   // 🔥 OVO JE KLJUČ
  }}
  InputProps={{ style: { color: '#ff9800' } }}
  sx={fieldStyle}
/>
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={<Switch checked={status} onChange={e => setStatus(e.target.checked)} sx={{ color: '#ff9800' }} />}
                  label={<Typography sx={{ color: '#ff9800' }}>Status (aktivna)</Typography>}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField label="Current Power (W)" type="number" value={currentPower}
                  onChange={e => setCurrentPower(e.target.value)}
                  fullWidth margin="normal"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                  sx={fieldStyle}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField label="Current Dimming (%)" type="number" value={currentDimming}
                  onChange={e => setCurrentDimming(e.target.value)}
                  fullWidth margin="normal"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                  sx={fieldStyle}
                />
              </Grid>

            </Grid>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
              <Button variant="outlined" sx={{ color: '#ff9800', borderColor: '#ff9800' }} onClick={onCancel}>
                Odustani
              </Button>
              <Button variant="outlined" sx={{ color: '#ff9800', borderColor: '#ff9800' }} onClick={postData}>
                Spasi
              </Button>
            </Box>

          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}